import Overlay from './src/overlay'

export const LtOverlay = Overlay
export default LtOverlay

export * from './src/overlay'
